import { useNavigate } from 'react-router-dom';

const features = [
  { num: '01', title: 'Real-Time Inventory Visibility', desc: 'Live SKU counts with automated alerts before you run out.' },
  { num: '02', title: 'Order Tracking Dashboard', desc: 'Full tracking from pick to delivery with customer notifications.' },
  { num: '03', title: 'Analytics & Reporting', desc: 'Fulfillment speed, stock turnover, delivery performance in one view.' },
  { num: '04', title: 'Multi-Channel Integration', desc: 'Connect your store and marketplaces with no-code integrations.' },
];

const channels = [
  { name: 'Shopify', pct: 84 },
  { name: 'Jumia', pct: 67 },
  { name: 'Konga', pct: 49 },
  { name: 'Direct', pct: 92 },
];

export default function PlatformSection() {
  const navigate = useNavigate();
  return (
    <section className="py-24 px-6" style={{ background: '#0A0A0F' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <p className="eyebrow">Platform</p>
            <h2 className="section-heading mb-4">Logistics Intelligence at Your Fingertips</h2>
            <p className="section-lead mb-8">
              Our merchant portal gives you complete visibility over inventory, orders, and delivery, available 24/7.
            </p>
            <div className="flex flex-col gap-5 mb-8">
              {features.map(f => (
                <div key={f.num} className="flex gap-4 items-start">
                  <div className="text-thl-red font-bold text-lg w-8 shrink-0 mt-0.5">{f.num}</div>
                  <div>
                    <h4 className="text-white font-semibold text-sm mb-1">{f.title}</h4>
                    <p className="text-white/50 text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/technology')} className="btn-primary">
              Explore the Platform →
            </button>
          </div>

          {/* Dashboard widget */}
          <div className="bg-thl-dark3 border border-thl-border rounded-2xl overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-thl-border">
              <div className="flex items-center gap-1.5">
                {['#E8192C', '#E8A919', '#19E830'].map(c => (
                  <div key={c} className="w-2.5 h-2.5 rounded-full" style={{ background: c }} />
                ))}
              </div>
              <span className="text-white/60 text-xs font-semibold">THL Merchant Portal</span>
              <span className="text-xs text-green-400 font-semibold flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
                Live
              </span>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-4 gap-px bg-thl-border">
              {[
                { v: '1,284', k: 'Orders Today' },
                { v: '99.1%', k: 'SLA Rate' },
                { v: '4,760', k: 'Units in Stock' },
                { v: '4.2hr', k: 'Avg Fulfil Time' },
              ].map(s => (
                <div key={s.k} className="bg-thl-dark3 p-4">
                  <div className="text-white font-bold text-xl">{s.v}</div>
                  <div className="text-white/40 text-xs mt-1">{s.k}</div>
                </div>
              ))}
            </div>

            {/* Channel bars */}
            <div className="p-5">
              <div className="text-white/50 text-xs font-semibold uppercase tracking-wide mb-4">
                Fulfillment by Channel
              </div>
              <div className="flex flex-col gap-3">
                {channels.map(ch => (
                  <div key={ch.name} className="flex items-center gap-3">
                    <div className="text-white/60 text-xs w-14 shrink-0">{ch.name}</div>
                    <div className="flex-1 bg-white/10 rounded-full h-2">
                      <div
                        className="h-2 rounded-full bg-thl-red transition-all duration-700"
                        style={{ width: `${ch.pct}%` }}
                      />
                    </div>
                    <div className="text-white/60 text-xs w-8 text-right">{ch.pct}%</div>
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-thl-border flex items-center justify-between">
                <span className="text-green-400 text-xs">● Uptime 99.98%</span>
                <span className="text-white/30 text-xs">Updated just now</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
